import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DxCheckboxComponent} from "./ui/components/checkbox/dx-checkbox.component";
import {DxBaseControlComponent} from "./ui/components/dx-base-control.component";
import {DxComboboxComponent} from "./ui/components/combobox/dx-combobox.component";
import {DxDatepickerComponent} from "./ui/components/datepiker/dx-datepicker.component";
import {DxTimepickerComponent} from "./ui/components/timepiker/dx-timepicker.component";
import {DxInputComponent} from "./ui/components/input/dx-input.component";
import {DxTextareaComponent} from "./ui/components/textarea/dx-textarea.component";
import {SuiModule} from "ng2-semantic-ui";
import {MomentPipe} from "./pipes/moment.pipe";
import { DxRadiobuttonComponent } from './ui/components/radiobutton/dx-radiobutton.component';
import { DxTabsComponent } from './ui/components/tabs/dx-tabs.component';
import {DxTabTemplateDirective} from "./ui/directives/dx-tab-template.directive";
import {DxFileComponent} from './ui/components/file/dx-file.component';


/**
 * Модуль предоставляет комопненты для построения нетабличных форм ввода данных.
 * По-русски, различного рода карточек.
 */
@NgModule({
  declarations: [
    DxBaseControlComponent,
    DxCheckboxComponent,
    DxComboboxComponent,
    DxDatepickerComponent,
    DxTimepickerComponent,
    DxInputComponent,
    DxTextareaComponent,
    DxFileComponent,
    DxRadiobuttonComponent,
    MomentPipe,
    DxTabsComponent,
    DxTabTemplateDirective
  ],
  exports: [
    MomentPipe,
    DxCheckboxComponent,
    DxComboboxComponent,
    DxDatepickerComponent,
    DxTimepickerComponent,
    DxInputComponent,
    DxTextareaComponent,
    DxFileComponent,
    DxRadiobuttonComponent,
    DxTabsComponent,
    FormsModule,
    ReactiveFormsModule,
    DxTabTemplateDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SuiModule
  ],
  providers: [],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  bootstrap: []
})
export class DxFormsModule {

}
